import $ from 'jquery';

class Accordion {
    constructor(){
        const _this = this;
        const jssection = document.querySelectorAll('.js-accordion');
        jssection.forEach(function(js){
            const accors = js.querySelectorAll('.item-accordion');    
            const section = accors[0].closest('.js-accordion-container') || accors[0].closest('section');
            const thumbnails = section?.querySelectorAll(`.item-accordion-thumbnail`);
    
            accors.forEach((item, idx) => {
                const handle = item.dataset.handle;
                
                let head = item.querySelector('.item-accordion-head');
                let content = item.querySelector('.item-accordion-content');

                if (head){
                    head.addEventListener('click', (e) => {
                        head.classList.toggle('showed');
                        if (head.classList.contains('showed')){
                            item.classList.add('active');
                        }else{
                            item.classList.remove('active');
                        }

                        const hrefParent = e.target.href;
                        if (!hrefParent || hrefParent === '#' || hrefParent === 'javascript:void(0)') {
                        } else {
                            return true;
                        }
    
                        e.preventDefault();
                        if (head.classList.contains('showed')){
                            _this.jquerySlideDown(content);
    
                            accors.forEach(temp => {
                                let headTmp = temp.querySelector('.item-accordion-head');
                                let contentTmp = temp.querySelector('.item-accordion-content');
                                if (temp.dataset.handle !== handle){
                                    if (headTmp.classList.contains){
                                        headTmp.classList.remove('showed');
                                        if (head.classList.contains('showed')){
                                            item.classList.add('active');
                                        }else{
                                            item.classList.remove('active');
                                        }
                                        _this.jquerySlideUp(contentTmp);
                                    }
                                }
                            })
                            thumbnails.forEach((thumb)=>{
                                if (handle == thumb.dataset.accordion){
                                    if (thumb.classList.contains('hidden')){
                                        thumb.classList.remove('hidden');
                                    }
                                }else{
                                    thumb.classList.add('hidden');
                                }
                            })
                        }else{
                            _this.jquerySlideUp(content);
                            
                            thumbnails.forEach((thumb)=>{
                                thumb.classList.add('hidden');
                            })
                        }
    
                    })
                    if (idx === 0 && js.classList.contains('first-showed')){
                        head.classList.add('showed');
                        if (head.classList.contains('showed')){
                            item.classList.add('active');
                        }else{
                            item.classList.remove('active');
                        }
                        _this.jquerySlideDown(content);
    
                        thumbnails && thumbnails.forEach((thumb)=>{
                            if (handle == thumb.dataset.accordion){
                                thumb.classList.remove('hidden');
                            }else{
                                thumb.classList.add('hidden');
                            }
                        })
                    }else{
                        head.classList.remove('showed');
                        _this.jquerySlideUp(content);
                    }
                }
    
            });
        })
    }

    jquerySlideDown(element, duration = 250) {
        $(element).stop(true, true).slideDown(duration);
    }

    jquerySlideUp(element, duration = 250) {
        $(element).stop(true, true).slideUp(duration);
    }
}
export default Accordion;